var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3508_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.044 13.3055C46.7726 12.2843 46.2378 11.3523 45.493 10.6028C44.7483 9.85325 43.8197 9.31247 42.8003 9.03456C39.0476 8.02547 24.0476 8.02547 24.0476 8.02547C24.0476 8.02547 9.04761 8.02547 5.29488 9.03456C4.27547 9.31247 3.34693 9.85325 2.60218 10.6028C1.85744 11.3523 1.32262 12.2843 1.05124 13.3055C0.0476075 17.0746 0.0476074 24.9346 0.0476074 24.9346C0.0476074 24.9346 0.0476075 32.7946 1.05124 36.5636C1.32262 37.5848 1.85744 38.5168 2.60218 39.2663C3.34693 40.0159 4.27547 40.5566 5.29488 40.8346C9.04761 41.8436 24.0476 41.8436 24.0476 41.8436C24.0476 41.8436 39.0476 41.8436 42.8003 40.8346C43.8197 40.5566 44.7483 40.0159 45.493 39.2663C46.2378 38.5168 46.7726 37.5848 47.044 36.5636C48.0476 32.7946 48.0476 24.9346 48.0476 24.9346C48.0476 24.9346 48.0476 17.0746 47.044 13.3055Z",
    fill: "#FF0302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1385 32.0719V17.7973L31.684 24.9346L19.1385 32.0719Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3508_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.934555)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d270e6778ec03ea59f25b31e5bb5ce5a.svg";
export { ForwardRef as ReactComponent };